import { XClear } from '@/assets/icons'
import { NoSearchResults } from '@/assets/illustration'
import { Button } from '@/components/button/Button'

type SearchEmptyStateProps = {
  /** The committed query that matched nothing. */
  query: string
  onClearSearch: () => void
}

/**
 * SearchEmptyState
 *
 * Shown in place of the result rows when a query matches no file or folder name.
 * Follows the `matters-table/blank state` design: illustration, message pair, tonal clear action.
 */
export function SearchEmptyState({ query, onClearSearch }: SearchEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg px-4 py-6">
      <NoSearchResults className="h-10 w-auto shrink-0" aria-hidden />

      <div className="flex max-w-[460px] flex-col items-center gap-0.5 text-center">
        <p className="font-rethink-sans text-base font-medium leading-6 text-brand-neutral-950">
          No files or folders match &ldquo;<span className="break-all">{query}</span>&rdquo;
        </p>
        <p className="text-sm leading-5 tracking-[-0.15px] text-brand-neutral-600">
          Search matches file and folder names. Try a shorter term, or check for typos.
        </p>
      </div>

      <Button type="button" variant="tonal" color="neutral" size="sm" leadingIcon={<XClear className="h-4 w-4 shrink-0" aria-hidden />} onClick={onClearSearch}>
        Clear Search
      </Button>
    </div>
  )
}
